import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.paypal-cancelled', {
        url: '/paypal-cancelled?token',
        views: {
            '@company': 'companySmsServicesPaypalCancelled'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/paypal-cancelled/paypal-cancelled.state.js